import { EmployeeNPSElementResult } from "@/components/questionnaire/components/EmployeeNPSElement.tsx";
import { GoalsElementResult } from "@/components/questionnaire/components/GoalsElement.tsx";
import { OpenAnswerElementResult } from "@/components/questionnaire/components/OpenAnswerElement.tsx";
import { ScaleElementResult } from "@/components/questionnaire/components/ScaleElement.tsx";
import { SelectElementResult } from "@/components/questionnaire/components/SelectElement.tsx";
import { TextElementResult } from "@/components/questionnaire/components/TextElement.tsx";
import { WriteToFieldElementResult } from "@/components/form-result/result-modal/components/WriteToFieldElementResult.tsx";
import { FileElementResult } from "@/components/form-result/result-modal/components/FileElementResult.tsx";
import { ApiFormViewElement } from "@/types/forms/form-view.types.ts";

import { ApiFormElementType, ApiFormResultAnswer } from "@/types/forms/form.types.ts";
import { Stack } from "@skailer-com/uikit";

export const FormResultForEmployeeElement = ({
  element,
  answers,
}: {
  element: ApiFormViewElement;
  answers: ApiFormResultAnswer[];
}) => {
  const getElement = () => {
    const answer = answers.find((x) => {
      if (element.type === ApiFormElementType.goals) {
        return x.form_element_id === element.id && x.reference_id === element.reference_id;
      }

      return x.form_element_id === element.id;
    });

    switch (element.type) {
      case ApiFormElementType.text:
        return <TextElementResult element={element} />;

      case ApiFormElementType.open_answer:
        return <OpenAnswerElementResult element={element} answer={answer} />;

      case ApiFormElementType.scale:
        return <ScaleElementResult element={element} answer={answer} />;

      case ApiFormElementType.goals:
        return <GoalsElementResult element={element} answer={answer} />;

      case ApiFormElementType.select:
        return <SelectElementResult element={element} answer={answer} />;

      case ApiFormElementType.employee_nps:
        return <EmployeeNPSElementResult element={element} answer={answer} />;

      case ApiFormElementType.file:
        return <FileElementResult element={element} answer={answer} />;

      case ApiFormElementType.write_to_field:
        return <WriteToFieldElementResult element={element} answer={answer} />;

      default:
        return null;
    }
  };

  return <Stack>{getElement()}</Stack>;
};
